export default "__VITE_PUBLIC_ASSET__5ce8031d__"